export const SET_AUTH = 'setAuth'
export const PURGE_AUTH = 'purge_auth'
export const SET_ERROR = 'setError'